import { useNavigate, useLocation } from 'react-router-dom';
import { setSignOutModal } from '../../../store/auth/slice';
import { useDispatch, useSelector } from '../../../store/store';
import { items } from '../../../config/sidebar';
import styles from './style.module.scss';
import {
    ChevronRightIcon,
    LogOutIcon,
    TypographyLogo,
} from '../../../assets/icons/common';
import {
    setSideBarShow,
    setGetHelpModalShow,
    setSideBarExpanded,
} from '../../../store/workspace/slice';
import { selectSideBarExpanded } from '../../../store/workspace/selectors';

interface Props {
    show: boolean;
}

function SideBar(props: Props) {
    const { show } = props;
    const navigate = useNavigate();
    const location = useLocation()
    const dispatch = useDispatch();
    const sideBarExpanded = useSelector(selectSideBarExpanded);

    const itemClick = (path: string) => {
        if (path !== '/profile/help') {
            navigate(path);
            dispatch(setSideBarShow(false));
        } else {
            dispatch(setGetHelpModalShow(true));
        }
    };

    const toggleExpanded = () => {
        dispatch(setSideBarExpanded(!sideBarExpanded));
    };

    return (
        <div
            data-sidebar-open={show}
            className={styles.container}
            data-expanded={sideBarExpanded}
        >
            <div className={styles.header}>
                <TypographyLogo
                    width={121}
                    height={31}
                    className={styles.logo}
                />
                <button
                    onClick={toggleExpanded}
                    className={styles.toggleButton}
                    aria-label={sideBarExpanded ? 'Collapse sidebar' : 'Expand sidebar'}
                >
                    <ChevronRightIcon className={styles.toggleButton_icon} />
                </button>
            </div>

            {items.map((item, indx) => (
                <>
                    <div
                        className={styles.item}
                        onClick={() => itemClick(item.path)}
                        data-selected={(!location.pathname.split('/')[2] && item.path === '') ||
                            location.pathname.split('/')[2] === item.path}
                    >
                        <img src={item.icon} alt='' />
                        <span className={styles.item_title}>{item.title}</span>
                        <span className={styles.item_tooltip}>{item.title}</span>
                    </div>
                    {indx === 3 && <hr />}
                </>
            ))}

            <div
                data-place-end="true"
                className={styles.item}
                onClick={() => dispatch(setSignOutModal(true))}
            >
                <LogOutIcon />
                <span className={styles.item_title}>Sign out</span>
                <span className={styles.item_tooltip}>Sign out</span>
            </div>
        </div>
    );
};

export default SideBar
